import React, { PropTypes } from 'react';

import { NitroIcon } from 'nitro-components';

import styled from 'styled-components';

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  margin-bottom: 43px;
`;

const QuestionTitle = styled.div`
  font-family: ${props => props.theme.font.bold};
  color: ${props => props.theme.color.base1};
  letter-spacing: 0.45px;
`;
const QuestionAnswer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  margin-left: 10px;
`;
const QuestionIcon = styled.div`
  padding: 2px 16px 0 0;
`;
const QuestionContent = styled.div`
  line-height: 30px;
`;

const QuestionList = ({ list }) => {
  const lists = list.map((item, index) => (
    <ListItem key={index}>
      <QuestionTitle>{item.Question}</QuestionTitle>
      <QuestionAnswer>
        <QuestionIcon>
          <NitroIcon name="success-circle" size={16} variant="primary" />
        </QuestionIcon>
        <QuestionContent>{item.Answer}</QuestionContent>
      </QuestionAnswer>
    </ListItem>
  ));

  return (
    <List>
      {lists}
    </List>
  );
};

QuestionList.propTypes = {
  list: PropTypes.array
};

export default QuestionList;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/Question/QuestionList.js